import React from 'react';

const HostItem = ({
  label,
  value,
}: {
  label: string;
  value: string | React.ReactNode;
}) => {
  return (
    <div className='flex flex-col items-start gap-1.5'>
      <span className='font-medium text-base text-gray-800'>{label}</span>
      {typeof value === 'string' ? (
        <span className='text-sm font-normal text-gray-800'>{value}</span>
      ) : (
        value
      )}
    </div>
  );
};

export default HostItem;
